import Vue, { AsyncComponent } from 'vue';
import Router, { RouteConfig, Route } from 'vue-router';
import Home from '../views/Home.vue';
import VueMeta from 'vue-meta';

Vue.use(Router);
Vue.use(VueMeta);

const lazy = (name: string): AsyncComponent => {
  return () => import(`@/views/${name}.vue`);
};

export const ROUTE_HOME = 'Home';
export const ROUTE_ALPACAS = 'Alpacas';
export const ROUTE_ADOPT = 'Adopt';
export const ROUTE_ALPACA = 'Alpaca';
export const ROUTE_BREEDING = 'Breeding';
export const ROUTE_STAKE = 'Stake';
export const ROUTE_FARM = 'Farm';
export const ROUTE_FARM_TAB = 'FarmTab';
export const ROUTE_BANK = 'Bank';
export const ROUTE_TOKEN_PRESALE = 'TokenPresale';
export const ROUTE_RECYCLE = 'Recycle';
export const ROUTE_RECYCLE_TAB = 'RecycleTab';
export const ROUTE_AIRDROP = 'Airdrop';
export const ROUTE_AIRDROP_TAB = 'AirdropTab';
export const ROUTE_SCARFS = 'Scarves';

const routes: RouteConfig[] = [
  {
    path: '/',
    name: ROUTE_HOME,
    component: Home,
  },
  {
    path: '/alpacas',
    name: ROUTE_ALPACAS,
    component: lazy('Alpacas'),
  },
  {
    path: '/adopt',
    name: ROUTE_ADOPT,
    component: lazy('Adopt'),
  },
  {
    path: '/alpaca/:alpacaID',
    name: ROUTE_ALPACA,
    component: lazy('AlpacaInfo'),
    props: true,
  },
  {
    path: '/breeding',
    name: ROUTE_BREEDING,
    component: lazy('Breeding'),
    props: (route) => ({
      selectedAlpaca: route.params.selectedAlpaca,
    }),
  },
  {
    path: '/stake',
    name: ROUTE_STAKE,
    component: lazy('Stake'),
  },
  {
    path: '/farm',
    name: ROUTE_FARM,
    component: lazy('Farm'),
  },
  {
    path: '/farm/:tab',
    name: ROUTE_FARM_TAB,
    component: lazy('Farm'),
    props: true,
  },
  {
    path: '/bank',
    name: ROUTE_BANK,
    component: lazy('Bank'),
  },
  {
    path: '/tokenpresale',
    name: ROUTE_TOKEN_PRESALE,
    component: lazy('TokenPresale'),
  },
  {
    path: '/tokenpresalewl',
    name: ROUTE_TOKEN_PRESALE,
    component: lazy('TokenPresaleWL'),
  },
  {
    path: '/recycle',
    name: ROUTE_RECYCLE,
    component: lazy('Trade'),
  },
  {
    path: '/recycle/:tab',
    name: ROUTE_RECYCLE_TAB,
    component: lazy('Trade'),
    props: true,
  },
  // {
  //   path: '/scarf/:scarfID',
  //   name: ROUTE_SCARF,
  //   component: lazy('ScarfInfo'),
  //   props: true,
  // },
  {
    path: '/scarves',
    name: ROUTE_SCARFS,
    component: lazy('Scarves'),
  },
  {
    path: '*',
    name: 'Not Fount',
    redirect: '/',
  },
];

const bscRoutes: RouteConfig[] = [
  {
    path: '/',
    name: ROUTE_HOME,
    component: Home,
  },
  {
    path: '/alpacas',
    name: ROUTE_ALPACAS,
    component: lazy('Alpacas'),
  },
  {
    path: '/adopt',
    name: ROUTE_ADOPT,
    component: lazy('Adopt'),
  },
  {
    path: '/airdrop',
    name: ROUTE_AIRDROP,
    component: lazy('Airdrop'),
  },
  {
    path: '/airdrop/:tab',
    name: ROUTE_AIRDROP_TAB,
    component: lazy('Airdrop'),
    props: true,
  },
  {
    path: '/alpaca/:alpacaID',
    name: ROUTE_ALPACA,
    component: lazy('AlpacaInfo'),
    props: true,
  },
  {
    path: '/breeding',
    name: ROUTE_BREEDING,
    component: lazy('Breeding'),
    props: (route) => ({
      selectedAlpaca: route.params.selectedAlpaca,
    }),
  },
  {
    path: '/farm',
    name: ROUTE_FARM,
    component: lazy('FarmBSC'),
  },
  {
    path: '/farm/:tab',
    name: ROUTE_FARM_TAB,
    component: lazy('FarmBSC'),
    props: true,
  },
  {
    path: '/recycle',
    name: ROUTE_RECYCLE,
    component: lazy('Trade'),
  },
  {
    path: '/recycle/:tab',
    name: ROUTE_RECYCLE_TAB,
    component: lazy('Trade'),
    props: true,
  },
  {
    path: '/scarves',
    name: ROUTE_SCARFS,
    component: lazy('Scarves'),
  },
  {
    path: '/bank',
    name: ROUTE_BANK,
    component: lazy('Bank'),
  },
  // {
  //   path: '/scarf/:scarfID',
  //   name: ROUTE_SCARF,
  //   component: lazy('ScarfInfo'),
  //   props: true,
  // },
  {
    path: '*',
    name: 'Not Fount',
    redirect: '/',
  },
];

const curRouters = () => {
  if (process.env.VUE_APP_BSC) {
    return bscRoutes;
  }
  return routes;
};

const router = new Router({
  mode: 'history',
  routes: curRouters(),
  scrollBehavior(to, from, savedPosition) {
    const view = document.getElementById('view');
    if (view) {
      view.scrollTop = 0;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
